(function () {
  async function postJSON(url, data) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`${url} failed: ${res.status}`);
    return res.json();
  }

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`/cart.js failed: ${res.status}`);
    return res.json();
  }

  function refreshDrawer() {
     document.dispatchEvent(new CustomEvent("theme:cart:update", { bubbles: true }));
     document.dispatchEvent(new CustomEvent("theme:cart:refresh", { bubbles: true }));
  }

  // EVENT DELEGATION: survives drawer re-renders
  document.addEventListener("change", async (e) => {
    const el = e.target;
    if (!el || !el.matches("[data-gift-wrap-toggle]")) return;

    const variantId = Number(el.getAttribute("data-gift-wrap-variant-id"));
    const attrName = el.getAttribute("data-gift-wrap-attr-name") || "Gift wrap";

    el.disabled = true;

    try {
      if (el.checked) {
        // 1) set attribute (optional but nice)
        await postJSON("/cart/update.js", { attributes: { [attrName]: "Yes" } });

        // 2) add gift wrap variant
        await postJSON("/cart/add.js", { items: [{ id: variantId, quantity: 1 }] });

      } else {
        // 1) clear attribute
        await postJSON("/cart/update.js", { attributes: { [attrName]: "" } });

        // 2) remove the gift wrap line (lookup fresh cart, don’t rely on old line key)
        const cart = await getCart();
        const gwItem = cart.items.find((i) => i.variant_id === variantId);

        if (gwItem && gwItem.key) {
          await postJSON("/cart/change.js", { id: gwItem.key, quantity: 0 });
        }
      }

      refreshDrawer();
    } catch (err) {
      console.error("[Gift wrap] error:", err);
      // revert checkbox on failure
      el.checked = !el.checked;
    } finally {
      el.disabled = false;
    }
  });
})();